import React from 'react';
import { Dna, HeartPulse, FlaskConical, Users } from 'lucide-react';
import ServiceComingSoon from './ServiceComingSoon';
import logo from '../../assets/img/brand/human-genetics-icon.jpg';

const HumanGeneticsLanding: React.FC = () => {
  return (
    <ServiceComingSoon
      serviceId="human-genetics"
      accent="#3a7bf5"
      accentDark="#2457c4"
      accentSoft="rgba(58, 123, 245, 0.16)"
      logo={logo}
      logoAlt="iGiTREE Human Genetics"
      kicker="Coming Soon"
      title="The Future of Personal Genomics Is Coming"
      subtitle="Introducing iGiTREE Human Genetics"
      description="Unlocking genomic insights for healthier people and stronger communities through science and data-driven care."
      features={[
        {
          icon: <Dna size={24} strokeWidth={1.75} />,
          title: 'Genetic Risk Insights',
          description: 'Understand the genetics behind your health.',
        },
        {
          icon: <HeartPulse size={24} strokeWidth={1.75} />,
          title: 'Preventive Health',
          description: 'Act early with personalised guidance.',
        },
        {
          icon: <FlaskConical size={24} strokeWidth={1.75} />,
          title: 'Precision Medicine',
          description: 'Support treatment tailored to you.',
        },
        {
          icon: <Users size={24} strokeWidth={1.75} />,
          title: 'Family Health History',
          description: 'See patterns across generations.',
        },
      ]}
      audienceQuestion="Are you an individual, healthcare provider or research partner?"
      audienceOptions={[
        { label: 'Individual', value: 'individual' },
        { label: 'Healthcare Provider', value: 'provider' },
        { label: 'Research Partner', value: 'research' },
      ]}
    />
  );
};

export default HumanGeneticsLanding;
